module.exports = __webpack_public_path__ + "assets/Kappa.8123fe4ed246dae58206544694c99fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Kappa.png
// module id = 788
// module chunks = 0